<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="showUploadDocuments ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!-- table-->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- number -->
        <td>
          <td-value copyToClipboard [value]="item?.number"></td-value>
        </td>

        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- payAmount -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.payAmount"
          ></td-value>
        </td>

        <!-- isService -->
        <td>
          <td-value type="boolean" [value]="item?.isService"></td-value>
        </td>

        <!-- private Number Bu yRequest -->
        <td class="dir-rtl">
          <span
            [privateNumberBuyRequestStatus]="
              item?.privateNumberBuyRequestStatus
            "
            [matTooltip]="
              item?.privateNumberBuyRequestStatus
                | enumToText : PrivateNumberBuyRequestStatusEnumValues
            "
          >
          </span>
        </td>

        <!-- rejectionDescription -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.rejectionDescription"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!-------------------------------- operations ------------------------------->
        @if( item?.privateNumberBuyRequestStatus ==
        PrivateNumberBuyRequestStatus.WaitingDocumentsUpload){
        <td class="sticky-td">
          <div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <div app-menu-btn icon="mdi mdi-file-document-outline mdi-20px" color="blue" [title]="'common.uploadDocuments'"
                 (click)="onShowUploadDocuments(item.id)"></div>
          </mat-menu>
        </td>
        } @else{
        <td class="sticky-td"></td>
        }
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!---------------------------------- upload documents ---------------------------------->

<!-- upload documents form -->
<ng-container *ngIf="showUploadDocuments">
  <app-private-number-upload-documents-form
    [requestId]="requestId"
    (closeFormPage)="
      showUploadDocuments = false; showParent = true; getParentQueryString()
    "
  >
  </app-private-number-upload-documents-form>
</ng-container>

<!---------------------------------------- Audit ---------------------------------------->

<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!---------------------------------------- help ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
